<template>
  <div class="bg-white m-3 rounded-md p-2 min-h-screen">
    <div class="flex gap-10 m-3">
      <label class="b-contain">
        <span>Fixed</span>
        <input v-model="selectedType" value="fixed" type="radio" />
        <div class="b-input"></div>
      </label>
      <label class="b-contain">
        <span>Flexi</span>
        <input v-model="selectedType" type="radio" value="flexi" />
        <div class="b-input"></div>
      </label>
    </div>
    <flexi v-if="selectedType == 'flexi'"></flexi>
    <fixed v-if="selectedType == 'fixed'"></fixed>
  </div>
</template>

<script>
import Flexi from "./flexi.vue";
import Fixed from "./fixed.vue";
export default {
  name: "WorkHours",
  components: {
    Flexi,
    Fixed,
  },
  data() {
    return {
      selectedType: "flexi",
    };
  },
};
</script>